var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-img',{class:{large: _vm.large, 'small': !_vm.large},attrs:{"src":require(`@/assets/${this.fileName}`),"alt":"Astrid Beauty Logo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }